import { MAPBOX_DEV_TOKEN } from './tokens';
import { IEnvironment } from './interfaces';

/**
 * Settings for branch feature
 * @type {{env: Deploy; production: boolean; test: boolean}}
 */
export const environment: IEnvironment = {
  buildTarget: 'feature',
  callbackURL: location.origin + '/callback',
  silentURL: location.origin + '/silent.html',
  assetRoot: location.origin + '/assets',
  websocketURL: 'https://api-develop.miprorego.io/clientmessages',
  apiURL: 'https://api-develop.miprorego.io/map/v1/',
  regoApiURL: 'https://api-rb-develop.miprorego.io/rego/v1/',
  dataApiURL: 'https://data-dev.miprorego.io/data/v1/datas/',
  apigwURL: 'https://apigw-develop.miprorego.io/',
  geojsonURL: 'https://dev-rego-geojson.s3.eu-central-1.amazonaws.com',
  production: true,
  mapboxToken: MAPBOX_DEV_TOKEN
};
